import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NodeLink = ({ type, label }) => {
  return type in dblinks ? (
    <span>
      {label} &nbsp;
      <a href={`${dblinks[type]}${label}`} target="_blank">
        <FontAwesomeIcon
          icon="fa-solid fa-arrow-up-right-from-square"
          color={"#4169e1"}
        />
      </a>
    </span>
  ) : (
    <p>{label}</p>
  );
};

export default NodeLink;

const dblinks = {
  ENSEMBL: "http://www.ensembl.org/id/",
  ENTREZID: "https://www.ncbi.nlm.nih.gov/gene/",
  UNIPROT: "https://www.uniprot.org/uniprotkb/",
  ORF: "https://www.yeastgenome.org/locus/",
  TAIR: "https://www.arabidopsis.org/servlets/TairObject?type=locus&name=",
  ALIAS: "https://www.uniprot.org/uniprotkb?query=",
  ENSEMBL_PROT: "http://www.ensembl.org/id/",
  ENSEMBL_TRANS: "http://www.ensembl.org/id/",
  ENZYME: "https://enzyme.expasy.org/EC/",
  PFAM: "http://pfam.xfam.org/family/",
  REFSEQ: "https://www.ncbi.nlm.nih.gov/search/all/?term=",
  SGD: "https://www.yeastgenome.org/locus/",
  SYMBOL: "https://www.uniprot.org/uniprotkb?query=gene:",
  WORMBASE: "http://www.wormbase.org/db/gene/gene?name=",
  ZFIN: "https://zfin.org/",
};
